// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".faq-section-content[data-v-45443006]{max-height:0}.faq-section.expanded .faq-section-content[data-v-45443006]{max-height:2000px}.fa-icon[data-v-45443006]{top:.3rem}.expanded .fa-icon[data-v-45443006]{top:.4rem}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
